/* FUEBC Coffee — theme behavior (header, quantity, variants, add-to-cart) */
(function () {
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  /* ---------- Header: sticky shrink + mobile menu (from 01-header.html) ---------- */
  var header = document.querySelector('[data-header]');
  if (header) {
    var ticking = false;
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
      ticking = false;
    };
    window.addEventListener('scroll', function () {
      if (!ticking) { window.requestAnimationFrame(onScroll); ticking = true; }
    }, { passive: true });
    onScroll();

    var burger = header.querySelector('[data-burger]');
    var panel = header.querySelector('[data-mobile-panel]');
    if (burger && panel) {
      burger.addEventListener('click', function () {
        var open = panel.classList.toggle('is-open');
        burger.classList.toggle('is-open', open);
        burger.setAttribute('aria-expanded', open);
        burger.setAttribute('aria-label', open ? 'Close menu' : 'Open menu');
      });
    }
  }

  /* ---------- Open links to other sites in a new tab (same as church embeds) ---------- */
  function host(h) { return h.replace(/^www\./, ''); }
  document.addEventListener('click', function (e) {
    var a = e.target.closest && e.target.closest('a[href]');
    if (!a || !/^https?:$/.test(a.protocol)) return;
    if (host(a.hostname) !== host(window.location.hostname)) {
      a.target = '_blank';
      a.rel = 'noopener';
    }
  }, true);

  /* ---------- Quantity steppers ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-step]');
    if (!btn) return;
    var input = btn.closest('[data-qty]').querySelector('input');
    var min = parseInt(input.min || '0', 10);
    var next = Math.max(min, (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10));
    input.value = next;
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------- Collection sort ---------- */
  var sort = document.querySelector('[data-sort]');
  if (sort) {
    sort.addEventListener('change', function () {
      var url = new URL(window.location.href);
      url.searchParams.set('sort_by', sort.value);
      url.searchParams.delete('page');
      window.location.href = url.toString();
    });
  }

  /* ---------- Login: show password recovery ---------- */
  var recoverToggle = document.querySelector('[data-toggle-recover]');
  if (recoverToggle) {
    recoverToggle.addEventListener('click', function (e) {
      e.preventDefault();
      document.querySelector('[data-recover-panel]').classList.add('is-open');
      document.querySelector('[data-recover-panel] input').focus();
    });
  }

  /* ---------- Product page: variant picker + gallery ---------- */
  var productEl = document.querySelector('[data-product]');
  if (productEl) {
    var mainMedia = productEl.querySelector('[data-main-media]');
    var showImage = function (src) {
      var img = mainMedia && mainMedia.querySelector('img');
      if (img && src) { img.removeAttribute('srcset'); img.src = src; }
    };

    productEl.querySelectorAll('[data-thumb]').forEach(function (thumb) {
      thumb.addEventListener('click', function () {
        productEl.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('is-active'); });
        thumb.classList.add('is-active');
        showImage(thumb.getAttribute('data-thumb'));
      });
    });

    var json = productEl.querySelector('[data-product-json]');
    var form = productEl.querySelector('[data-product-form]');
    if (json && form) {
      var variants = JSON.parse(json.textContent).variants;
      var idInput = form.querySelector('[data-variant-id]');
      var addBtn = form.querySelector('[data-add-button]');
      var priceEl = productEl.querySelector('.product-price [data-price]');

      var selected = function () {
        var vals = [];
        form.querySelectorAll('[data-option-index]:checked').forEach(function (r) {
          vals[parseInt(r.getAttribute('data-option-index'), 10)] = r.value;
        });
        return vals;
      };

      form.addEventListener('change', function (e) {
        if (!e.target.matches('[data-option-index]')) return;
        var vals = selected();
        var v = variants.find(function (x) {
          return x.options.every(function (o, i) { return o === vals[i]; });
        });
        if (!v) {
          setAddState(addBtn, 'Unavailable', false);
          return;
        }
        idInput.value = v.id;
        setAddState(addBtn, v.available ? 'Add to cart' : 'Sold out', v.available);
        if (priceEl) {
          priceEl.classList.toggle('price-sale', !!v.compare);
          priceEl.innerHTML = v.price + (v.compare ? ' <s class="price-compare">' + v.compare + '</s>' : '');
        }
        if (v.image) showImage(v.image);
        var url = new URL(window.location.href);
        url.searchParams.set('variant', v.id);
        window.history.replaceState({}, '', url.toString());
      });
    }
  }

  /* ---------- Store hours: open/closed (logic in snippets/store-hours.liquid) ---------- */
  // Add buttons remember their real label/availability so closing and
  // reopening (or switching variants while closed) always restores correctly.
  function setAddState(btn, label, enabled) {
    btn.setAttribute('data-label', label);
    btn.setAttribute('data-enabled', enabled ? '1' : '');
    syncOrdering();
  }

  function closedMessage(state) {
    var copyEl = document.querySelector('[data-closed-copy]');
    var copy = copyEl ? JSON.parse(copyEl.textContent) : {};
    if (state.forced || !state.next) return copy.forced || '';
    return (copy.message || '').replace('{next}', state.next);
  }

  function syncOrdering() {
    var state = (window.StoreHours && window.StoreHours.state) || { open: true };
    var message = state.open ? '' : closedMessage(state);

    document.querySelectorAll('[data-closed-message]').forEach(function (el) { el.textContent = message; });

    document.querySelectorAll('[data-add-button]').forEach(function (btn) {
      if (!btn.hasAttribute('data-label')) {
        btn.setAttribute('data-label', btn.textContent.trim());
        btn.setAttribute('data-enabled', btn.disabled ? '' : '1');
      }
      if (state.open) {
        btn.textContent = btn.getAttribute('data-label');
        btn.disabled = !btn.getAttribute('data-enabled');
      } else {
        btn.textContent = state.forced || !state.next ? 'Ordering paused' : 'Ordering opens ' + state.next;
        btn.disabled = true;
      }
    });

    document.querySelectorAll('[name="checkout"]').forEach(function (btn) {
      btn.disabled = !state.open;
      btn.setAttribute('aria-disabled', String(!state.open));
    });

    document.querySelectorAll('[data-store-status]').forEach(function (pill) {
      pill.hidden = false;
      pill.classList.toggle('is-closed', !state.open);
      pill.textContent = state.open
        ? (state.closesAt ? 'Open now · until ' + state.closesAt : 'Open now')
        : (state.next && !state.forced ? 'Closed · opens ' + state.next : 'Closed');
    });
  }

  if (window.StoreHours) {
    syncOrdering();
    // Re-check every minute so the page flips open/closed without a reload.
    setInterval(function () {
      try { window.StoreHours.apply(); } catch (e) { return; }
      syncOrdering();
    }, 60000);
  }

  /* ---------- AJAX add to cart + toast ---------- */
  var toast = document.querySelector('[data-toast]');
  var toastTimer;
  function showToast(msg) {
    if (!toast) return;
    toast.querySelector('[data-toast-msg]').textContent = msg;
    toast.hidden = false;
    requestAnimationFrame(function () { toast.classList.add('is-visible'); });
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () { toast.hidden = true; }, 300);
    }, 3500);
  }

  function refreshCount() {
    return fetch(root + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.classList.remove('is-bumped');
          void el.offsetWidth;
          el.classList.add('is-bumped');
        });
      });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    var hours = window.StoreHours && window.StoreHours.state;
    if (hours && !hours.open && (form.matches('[data-ajax-cart]') || form.matches('[action*="/cart/add"]'))) {
      e.preventDefault();
      showToast(closedMessage(hours) || 'Online ordering is closed right now');
      return;
    }
    if (!form.matches('[data-ajax-cart]')) return;
    if (e.submitter && e.submitter.closest('.shopify-payment-button')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;

    fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: new FormData(form)
    })
      .then(function (r) {
        return r.json().then(function (body) {
          if (!r.ok) throw new Error(body.description || body.message || 'Could not add to cart');
          return body;
        });
      })
      .then(function (item) {
        showToast((item.product_title || 'Item') + ' added to cart');
        return refreshCount();
      })
      .catch(function (err) { showToast(err.message); })
      .finally(function () { if (btn) btn.disabled = false; });
  });
})();
